<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="created_at" label="Date et heure du commentaire">
            <el-date-picker v-model="form.created_at" type="datetime"
                            placeholder="Selectionnez une date et une heure" class="form-control"
                            :picker-options="fields.created_at" format="dd/MM/yyyy à HH:mm">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="customer_id" label="Client">
            <el-select v-model="form.customer_id" filterable remote :remote-method="searchCustomer"
                       class="form-control" placeholder="Select">
              <customer v-for="customer in fields.customers" :key="customer.id" :item="customer" present="option"></customer>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="pull-right"><el-button @click="form.description = bold('comment_comment')" size="small"><i class="zmdi zmdi-format-bold"></i></el-button></div>
      <el-form-item prop="description" label="Description">
        <el-input id="comment_comment" type="textarea" autosize placeholder="Saisissez la description de votre commentaire"
                  v-model="form.description"></el-input>
      </el-form-item>

      <div class="text-center">
        <el-button type="text" v-on:click="advanced = !advanced">
          <i class="fa fa-sort-down"></i> Plus d'options
        </el-button>
      </div>

      <el-col v-if="advanced">
        <el-form-item label="Commercial" prop="user_id">
          <el-select v-model="form.user_id" class="form-control" placeholder="Select">
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="this.form.id !== null" type="danger" :plain="true" v-delete:comment="this.form" class="pull-left">Supprimer</el-button>
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit()">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { MessageBox } from 'element-ui'
  import moment from 'moment'
  import Customer from '../Entities/Customer.vue'

  export default {
    components: {Customer},
    name: 'comment-modal',
    props: ['defaultBadge'],
    data () {
      return {
        visible: false,
        advanced: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        fields: {
          validation: {
            customer_id: [
              {required: true, message: 'Vous devez selectionner un client'}
            ],
            description: [
              {required: true, message: 'Vous devez saisir une description'}
            ]
          },
          customers: []
        },
        form: {
          id: null,
          customer_id: null,
          user_id: this.$store.getters['users/current'].id,
          badge: this.keystone.config.components.modals.comment['default_badge'],
          description: '',
          created_at: moment()
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.comment.on('create', ({item, options}) => {
        self.content.title = 'Création d\'un commentaire'
        self.content.button = 'Créer le commentaire'
        self.content.button_type = 'success'

        self.load(item)

        self.visible = true
      })

      this.$model.comment.on('edit', ({item}) => {
        self.content.title = 'Modification d\'un commentaire'
        self.content.button = 'Modifier le commentaire'
        self.content.button_type = 'warning'

        self.load(item)

        self.visible = true
      })

      this.$model.comment.on('delete', ({item}) => {
        MessageBox.confirm('Souhaitez-vous réellement supprimer ce commentaire ?', 'Confirmation', {
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
          confirmButtonClass: 'el-button--danger'
        }).then(() => {
          self.$model.comment.api().delete(item.id)
        }).catch(() => {

        })
      })
    },
    methods: {
      bold (id) {
        let el = $('#' + id).find('textarea', 0)
        let selection = {
          start: $(el).prop('selectionStart'),
          end : $(el).prop('selectionEnd') + 1
        }

        let val = $(el).val()
        let selectionStart = {
          before: val.substring(0,  selection.start),
          after:  val.substring(selection.start, val.length)
        }
        val = selectionStart.before + '*' + selectionStart.after

        let selectionEnd = {
          before: val.substring(0,  selection.end),
          after:  val.substring(selection.end, val.length)
        }
        val = selectionEnd.before + '*' + selectionEnd.after
        return val
      },
      searchCustomer (query) {
        let self = this

        if (query.length > 2) {
          this.$nexus.get('crm2', 'customers/search', {params: {query}}).then(response => {
            self.fields.customers = response.data.data
          })
        }
      },
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      load (item) {
        let self = this

        if (item) {
          if (item.id) this.form.id = item.id
          if (item.description) this.form.description = item.description
          if (item.customer_id) {
            this.$nexus.get('crm2', 'customers', {params: {where: {id: item.customer_id}}}).then(response => {
              self.fields.customers = response.data.data
              self.form.customer_id = item.customer_id
            })
          }
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            if (this.form.id === null) {
              p = self.$model.comment.api().create(this.form)
            } else {
              p = self.$model.comment.api().update(this.form.id, this.form)
            }

            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      users () {
        return this.$store.getters['users/all']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CommentModal.vue?2089fca4